// Get followers for a user
export async function fetchFollowers(targetUsername, status) {
  try {
    const query = `/api/db/followers?type=followers&targetUsername=${targetUsername}`;
    const response = await fetch(status ? `${query}&status=${status}` : query);
    if (!response.ok) {
      const error = await response.json();
      return {
        error: error.error || 'Network response was not ok'
      };
    }
    const data = await response.json();
    return {
      data
    };
  } catch (error) {
    console.error('Error fetching followers: zzzzz', error);
    return {
      error: error.message
    };
  }
}
// Get following list for a user
export async function fetchFollowing(targetUsername, status, getFeed) {
  try {
    const query = `/api/db/followers?type=following&targetUsername=${targetUsername}&getFeed=${getFeed}`;
    const response = await fetch(status ? `${query}&status=${status}` : query);
    if (!response.ok) {
      const error = await response.json();
      return {
        error: error.error || 'Network response was not ok'
      };
    }
    const data = await response.json();
    return {
      data
    };
  } catch (error) {
    console.error('Error fetching following list:', error);
    return {
      error: error.message
    };
  }
}
// Get pending follow requests
export async function fetchPendingFollowRequests(username) {
  try {
    const response = await fetch(`/api/db/followers?type=pending&targetUsername=${username}`);
    if (!response.ok) {
      const error = await response.json();
      return {
        error: error.error || 'Network response was not ok'
      };
    }
    const data = await response.json();
    return {
      data
    };
  } catch (error) {
    console.error('Error fetching pending requests:', error);
    return {
      error: error.message
    };
  }
}
// Follow a user
export async function followUser(username, userToFollow) {
  try {
    console.log('following', username, userToFollow);
    const response = await fetch('/api/db/followers', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username,
        userToFollow
      })
    });
    if (!response.ok) {
      const error = await response.json();
      return {
        error: error.error || 'Network response was not ok'
      };
    }
    const data = await response.json();
    return {
      data
    };
  } catch (error) {
    console.error('Error following user:', error);
    return {
      error: error.message
    };
  }
}
// Unfollow a user
export async function unfollowUser(username, userToUnfollow) {
  try {
    const response = await fetch('/api/db/followers', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username,
        userToUnfollow
      })
    });
    if (!response.ok) {
      const error = await response.json();
      return {
        error: error.error || 'Network response was not ok'
      };
    }
    const data = await response.json();
    return {
      data
    };
  } catch (error) {
    console.error('Error unfollowing user:', error);
    return {
      error: error.message
    };
  }
}
// Update follow status (approve/block/etc)
export async function updateFollowStatus(followerUsername, newStatus) {
  try {
    const response = await fetch('/api/db/followers', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        followerUsername,
        newStatus
      })
    });
    if (!response.ok) {
      const error = await response.json();
      return {
        error: error.error || 'Network response was not ok'
      };
    }
    const data = await response.json();
    return {
      data
    };
  } catch (error) {
    console.error('Error updating follow status:', error);
    return {
      error: error.message
    };
  }
}
// Helper to check if a user is following another
export async function checkFollowStatus(username, targetUsername) {
  var _a;
  try {
    const followingResult = await fetchFollowing(username);
    if (followingResult.error) {
      return {
        error: followingResult.error
      };
    }
    const followingUser = (_a = followingResult.data) === null || _a === void 0 ? void 0 : _a.find(f => f.username === targetUsername);
    return {
      data: {
        isFollowing: !!followingUser,
        status: (followingUser === null || followingUser === void 0 ? void 0 : followingUser.status) || null
      }
    };
  } catch (error) {
    console.error('Error checking follow status:', error);
    return {
      error: error.message
    };
  }
}